interface ProgressBarProps {
  current: number;
  total: number;
  label: string;
}

/** Fortschritt als Segment-Kette im Story-Stil, plus Text für `aria-valuenow` (A11Y-005). */
export function ProgressBar({ current, total, label }: ProgressBarProps) {
  const segments = Array.from({ length: total }, (_, index) => index < current);

  return (
    <div>
      <p className="progress-label">{label}</p>
      <div
        className="progress-steps"
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={label}
      >
        {segments.map((filled, index) => (
          <span
            key={index}
            className="progress-steps__segment"
            data-filled={filled}
            data-current={index === current - 1}
          />
        ))}
      </div>
    </div>
  );
}
